import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Alert, Snackbar } from '@mui/material/';
import { TlAlertDispatch } from './tl-alert-dispatch';

const TlAlert = ({ alert, alertSx, horizontalAlign, snackbarSx, verticalAlign }) => {
  const dispatch = useContext(TlAlertDispatch);
  const { status, message, errors, autoHideDuration = 3000 } = alert;
  const nullAlert = { status: null, message: '', errors: {} };

  const renderErrors = () => {
    return Object.keys(errors)
      .map((error) => `${error === '/' ? 'Error' : error.replace('/', '')}: ${errors[error]}`)
      .join(', ');
  };

  return (
    <React.Fragment>
      {status && (
        <Snackbar
          open={Boolean(status)}
          autoHideDuration={autoHideDuration}
          onClose={() => dispatch(nullAlert)}
          anchorOrigin={{ vertical: verticalAlign, horizontal: horizontalAlign }}
          sx={snackbarSx}
        >
          <Alert onClose={() => dispatch(nullAlert)} severity={status} sx={alertSx}>
            {errors && Object.keys(errors).length ? renderErrors() : message}
          </Alert>
        </Snackbar>
      )}
    </React.Fragment>
  );
};

TlAlert.defaultProps = {
  alertSx: null,
  snackbarSx: null,
  horizontalAlign: 'center',
  verticalAlign: 'bottom',
};

TlAlert.propTypes = {
  alert: PropTypes.shape({
    status: PropTypes.string,
    message: PropTypes.string,
    errors: PropTypes.shape({}),
    autoHideDuration: PropTypes.number,
  }).isRequired,
  alertSx: PropTypes.shape({}),
  snackbarSx: PropTypes.shape({}),
  horizontalAlign: PropTypes.oneOf(['center', 'left', 'right']),
  verticalAlign: PropTypes.oneOf(['bottom', 'top']),
};

export default TlAlert;
